import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/Logo";
import { BRAND } from "@/config/brand";

function AuthShell({ children, testId }) {
  return (
    <div className="flex min-h-screen bg-ivory" data-testid={testId}>
      <aside className="grain relative hidden w-[44%] flex-col justify-between overflow-hidden bg-bx p-12 text-white lg:flex">
        <div className="pointer-events-none absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full border border-gold/20" aria-hidden />
        <Logo light />
        <div className="relative z-10">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Ma première vidéo UGC</p>
          <h1 className="mt-4 text-4xl font-semibold leading-tight">De l'idée à ta première vidéo, <em className="font-medium text-gold">pas à pas.</em></h1>
          <p className="mt-4 max-w-sm text-white/75">Ton compte garde ta progression et tes réponses, sur tous tes appareils.</p>
        </div>
        <img src={BRAND.logoFull} alt="" className="relative z-10 h-24 w-24 rounded-2xl ring-1 ring-gold/40" />
      </aside>
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-10">
        <div className="mb-8 lg:hidden"><Logo /></div>
        {children}
      </main>
    </div>
  );
}

export function SignInPage() {
  return (
    <AuthShell testId="sign-in-page">
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/mon-espace" />
    </AuthShell>
  );
}

export function SignUpPage() {
  return (
    <AuthShell testId="sign-up-page">
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/mon-espace" />
    </AuthShell>
  );
}
